import Header from "../components/Header";

import Table from 'react-bootstrap/Table';
import Badge from "react-bootstrap/Badge";
import Image from "react-bootstrap/Image";
import { useState, useEffect, Fragment } from "react";

import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

import { ObjectStatus, StatusIcon } from "../components/ObjectStatus";
import { postDataHelper, uploadFileHelper, postDataWithHeaderHelper, getDataHelper } from "../requests/PostRequests";
import { RxCross2 } from "react-icons/rx";

import NavBar from "../components/NavBar";

import { Button } from "react-bootstrap";

import { getLanguage } from "../helpers/LanguageTranslation";
import { getLoggedInUserId } from '../helpers/session';
import { DeleteConfirmation } from "../components/DeleteConfirmation";

import ClassesModal from "../components/ClassesModal";
import { LanguageDropdown } from "../components/LanguageDropdown";
import LocationsModal from "../components/LocationsModal";

/*******************************************************************************************************
 *  Declarations
 ******************************************************************************************************/
const ENTER_KEY = 13;

const defaultCourse = {
  id: null,
  course_code: "",
  image_url: "",
  tag: "",
  tags: [],
  course_translations: [],
  status: ObjectStatus.New,
};

const defaultTranslation = {
  id: null,
  name: "",
  description: "",
  language: "",
  status: ObjectStatus.New,
}

/*******************************************************************************************************
 *  Components
 ******************************************************************************************************/

const CourseTagBadgeDisplay = ({ id, tags, onCheckboxHandler }) => {
  return (
    <>
      {tags.map(function (c, i) {
        return (
          <Fragment key={`${id}_${i}_course_tag_display_badge_fragment_container`}>
            {c.status != ObjectStatus.Deleted
              ? <Badge
                className="course-card-tag-badge"
                onClick={() => onCheckboxHandler == undefined ? () => { } : onCheckboxHandler(c.tag)}
                key={`${id}_${i}_badge`}
                bg="custom-primary"
                style={{ padding: "3px 8px", margin: "3px" }}
                pill={true}
              >
                {c.tag}
              </Badge>
              : <Fragment key={`${id}_${i}_deleted_display_tag`} />}
          </Fragment>
        );
      })}
    </>
  );
};

const CourseTagBadge = ({ tags, onCheckboxHandler }) => {
  return (
    <>
      {tags.map(function (c, i) {
        return (
          <Fragment key={`${i}_course_tag_badge_fragment_container`}>
            {c.status != ObjectStatus.Deleted
              ? <Badge
                className="p-2 tags-badge"
                onClick={() => onCheckboxHandler == undefined ? () => { } : onCheckboxHandler(c.tag)}
                key={`${c.tag}_option_badge_cancel`}
                bg="custom-secondary"
                style={{ padding: "3px 8px", margin: "3px" }}
                pill={true}
              >
                <div style={{ display: "flex", color: "#fff" }}>
                  {c.tag}
                  <RxCross2
                    className="tags-cross-icon"
                    key={`${c.tag}_option_cancel_icon`}
                    style={{ marginLeft: "5px" }}
                  />
                </div>
              </Badge>
              : <Fragment key={`${i}_deleted_tag`} />}
          </Fragment>
        );
      })}
    </>
  );
};

function CourseTranslationForm({ currentCourseId, translation, index, onChange, onDeleteTranslation }) {

  function onLanguageUpdate(index, languageCode) {
    const translationName = `translation.${index}.language`;
    onChange({ target: { name: [translationName], value: languageCode } });
  }

  return (
    <Fragment key={`${currentCourseId}_${index}_form_translation_fragment`}>
      <tr key={`${currentCourseId}_${index}_new_translation_row`} style={{ 'borderBottomWidth': 0 }}>
        {/* Managing translation language */}
        <td>
          <Form.Group
            className="mb-3"
            controlId={`translation_${index}.language`}
          >
            <LanguageDropdown key={`translation.${index}.language_dropdown`} value={translation.language} translationIndex={index} onUpdate={(languageCode) => onLanguageUpdate(index, languageCode)} />
          </Form.Group>
        </td>
        {/* Managing translation name */}
        <td>
          <Form.Group
            className="mb-3"
            controlId={`translation_${index}.name`}
          >
            <Form.Control name={`translation.${index}.name`} defaultValue={translation.name} placeholder="Name" onChange={onChange} />
          </Form.Group>
        </td>
        {/* Managing translation description */}
        <td>
          <Form.Group
            className="mb-3"
            controlId={`translation_${index}.description`}
          >
            <Form.Control name={`translation.${index}.description`} defaultValue={translation.description} placeholder="Course Translated Description" onChange={onChange} />
          </Form.Group>
        </td>
        {/* Delete translation */}
        <td><Button key={`translation.${index}.delete_button`} variant="danger" onClick={() => onDeleteTranslation(index)}>Delete</Button></td>
      </tr>
    </Fragment>
  );
}

function CourseForm({
  currentCourse,
  showFlag,
  onChange,
  onImageUpload,
  onTagChange,
  onTagClickDeleteHandler,
  onAddTranslation,
  onDeleteTranslation,
  onFormClose,
  onCreate,
  onUpdate }) {

  const hasImageSelected = currentCourse.image_url;
  const onSave = currentCourse.id == null ? onCreate : onUpdate;
  const name = currentCourse.course_translations.length > 0 ? currentCourse.course_translations[0].name : null;

  return (
    <Modal size="lg" centered backdrop="static" keyboard={false} show={showFlag} onHide={onFormClose}>
      <Modal.Header closeButton>
        <Modal.Title>{currentCourse.id == null ? "New Course" : name} <StatusIcon status={currentCourse.status} /></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {/* Set the course code */}
          <Form.Group
            className="mb-3"
            controlId="courseForm.courseCode"
          >
            <Form.Label>Course Code</Form.Label>
            <Form.Control name="courseCode" defaultValue={currentCourse.course_code} placeholder="Course Code" onChange={onChange} />
          </Form.Group>
          {/* Set the course tags */}
          <Form.Group
            className="mb-3"
            controlId="courseForm.tags"
          >
            <Form.Label>Add Tag</Form.Label>
            <Form.Control name="tag" value={currentCourse.tag} placeholder="Press enter to add tag" onChange={onChange} onKeyDown={onTagChange} />
          </Form.Group>
          <Form.Group
            className="mb-3"
            controlId="courseForm.displayTags"
          >
            <CourseTagBadge tags={currentCourse.tags} onCheckboxHandler={onTagClickDeleteHandler} />
          </Form.Group>
          <Image src={currentCourse.image_url} style={{ height: "5vw", width: "5vw" }} rounded />
          {/* Setting Image */}
          <Form.Group
            className="mb-3"
            controlId="courseForm.imageUrl"
          >
            <Form.Label>Image URL</Form.Label>
            <Form.Control name="imageUrl" defaultValue={currentCourse.image_url} disabled={hasImageSelected} placeholder="http://localhost:3102/images/course/1/p0.png" onChange={onChange} />
            <Form.Label>File Upload</Form.Label>
            <Form.Control name="imageFile" type="file" onChange={(e) => onImageUpload(e.target.files)} />
          </Form.Group>
          {/* Managing individual course translations */}
          <Table responsive>
            <thead>
              <tr key={`${currentCourse.id}_add_new_course_translation_row`} style={{ 'borderBottomWidth': 1 }}>
                <th>Language</th>
                <th>Name</th>
                <th>Description</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {
                currentCourse.course_translations.length > 0 ? currentCourse.course_translations.map(function (item, index) {
                  return (
                    <Fragment key={`${currentCourse.id}_${index}_course_translation_fragment_container`}>
                      {/* We only want to show items that are not deleted  */}
                      {item.status !== ObjectStatus.Deleted
                        ? <CourseTranslationForm
                          currentCourseId={currentCourse.id}
                          index={index}
                          translation={item}
                          onChange={onChange}
                          onDeleteTranslation={onDeleteTranslation} />
                        : <Fragment key={`${currentCourse.id}_${index}_deleted_translation_fragment`}></Fragment>
                      }
                    </Fragment>
                  );
                }) : <></>
              }
            </tbody>
          </Table>
          <Button onClick={onAddTranslation}>Add New Course Translations</Button>
        </Form>
      </Modal.Body >
      {/* User should be able to close or save current course changes */}
      <Modal.Footer>
        <Button variant="secondary" onClick={onFormClose}>
          Close
        </Button>
        <Button variant="primary" onClick={onSave}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal >
  );
}

const EditCourses = ({ onTriggerMessage }) => {

  const [isLoading, setIsLoading] = useState(false);
  const startLoading = () => setIsLoading(true);
  const stopLoading = () => setIsLoading(false);

  const [showCourseFormFlag, setShowCourseFormFlag] = useState(false);
  const showCourseForm = () => setShowCourseFormFlag(true);
  const closeCourseForm = () => setShowCourseFormFlag(false);

  const [showDeleteConfirmationFlag, setShowDeleteConfirmationFlag] = useState(false);
  const showDeleteConfirmation = () => setShowDeleteConfirmationFlag(true);
  const closeDeleteConfirmation = () => setShowDeleteConfirmationFlag(false);

  const [showClassesModalFlag, setShowClassesModalFlag] = useState(false);
  const showClassesModal = () => setShowClassesModalFlag(true);
  const closeClassesModal = () => setShowClassesModalFlag(false);

  const [showLocationsModalFlag, setShowLocationsModalFlag] = useState(false);
  const showLocationsModal = () => setShowLocationsModalFlag(true);
  const closeLocationsModal = () => setShowLocationsModalFlag(false);

  const [classes, setClasses] = useState({});
  const [trainers, setTrainers] = useState([]);
  const [locations, setLocations] = useState([]);

  const [currentCourse, setCurrentCourse] = useState(defaultCourse);
  let formValues = {};

  // Dictionary of courses with courseId as the key
  // courseId : { id: "", course_code: "", image_url: "", en: {}, zh: {}}
  const [courses, setCourses] = useState({});

  /*******************************************************************************************************
   *  API Functions
   ******************************************************************************************************/
  /**
   * This function will go through all the languages and load into `courses`
   * @param {[]} dictionary of courses
   * @param {[]} languages 
   */
  async function getCourses(languages, courses) {
    const language = languages.pop();

    const onSuccess = (data) => {
      let outgoingCourses = courses;
      const rows = data.result.rows;
      const length = rows.length;

      for (let i = 0; i < length; i++) {
        const courseId = parseInt(rows[i].id);
        if (!(courseId in outgoingCourses)) {
          // Process the tags once
          let tags = [];
          const tagsLength = rows[i].tags.length;
          for (let j = 0; j < tagsLength; j++) {
            tags.push({
              tag: rows[i].tags[j].tag,
              index: rows[i].tags[j].index,
              status: ObjectStatus.Sync,
            });
          }
          // If does not exist, we create them
          outgoingCourses[courseId] = {
            id: courseId,
            course_code: rows[i].course_code,
            image_url: rows[i].image_url,
            tag: "",
            tags: tags,
            status: ObjectStatus.Sync,
            likes: rows[i].likes,
            course_translations: [{
              id: rows[i].translation_id,
              language: language,
              name: rows[i].name,
              description: rows[i].description,
              status: ObjectStatus.Sync,
            }]
          };
        } else {
          // if exist, we just add to the language
          outgoingCourses[courseId].course_translations.push({
            id: rows[i].translation_id,
            language: language,
            name: rows[i].name,
            description: rows[i].description,
            status: ObjectStatus.Sync,
          });
        }
      }

      if (languages.length == 0) {
        setCourses(outgoingCourses);
      } else {
        // Remove one language and continue
        getCourses(languages, outgoingCourses);
      }
    };

    await postDataHelper("/v1/courses",
      { language: language },
      onTriggerMessage,
      onSuccess);
  }

  /**
   * Upload Course image to the server based on the input resource
   * @param {*} course 
   */
  async function uploadCourseImage(course) {
    const onSuccess = (data) => {
      let updatedCourse = course;
      updatedCourse.status = ObjectStatus.Updated;
      updatedCourse.image_url = data.result.rows[0].url;
      setCurrentCourse(updatedCourse);

      onTriggerMessage(
        "Success",
        "Successfully uploaded course image to the server",
      );
    };

    // Upload images
    await uploadFileHelper("/v1/courses/course/upload",
      {
        file_type: 'images',
        category: 'courses',
        owner: 'tmp',
        name: course.image_url,
        file: course.image_file
      }, onTriggerMessage, onSuccess);
  }

  async function postCourse(course) {
    const onSuccess = (data) => {
      const rows = data.result.rows;
      const newCourseId = rows[0].course_id;

      let updatedCourse = { ...course };
      updatedCourse.status = ObjectStatus.Sync;
      updatedCourse.id = newCourseId;
      updatedCourse.image_url = rows[0].image_url;
      updatedCourse.image_local = false;

      const translationLength = rows[0].translations.length;
      for (let i = 0; i < translationLength; i++) {
        const oldIndex = rows[0].translations[i].oldId;
        // Update the index of the created course translation based on the index of the translation in course
        updatedCourse.course_translations[oldIndex].id = rows[0].translations[i].newId;
      }

      updatedCourse.tags = updatedCourse.tags
        .map(function (item) { return { ...item, status: ObjectStatus.Sync } });

      updatedCourse.course_translations = updatedCourse.course_translations
        .map(function (item) { return { ...item, status: ObjectStatus.Sync } });

      setCurrentCourse(updatedCourse);
      setCourses({ ...courses, [newCourseId]: updatedCourse });

      onTriggerMessage(
        "Success",
        "Successfully uploaded course to the server",
      );

      closeCourseForm();
    };

    // Upload user guide
    await postDataWithHeaderHelper("/v1/courses/course/add", {
      course_code: course.course_code,
      user_id: getLoggedInUserId(),
      image_local: course.image_local,
      image_url: course.image_url,
      tags: course.tags.map(function (item, i) { return { tag: item.tag, index: i } }),
      course_translations: course.course_translations
        .filter((t) => t.status != ObjectStatus.Deleted)
        .map(function (item, i) { return { ...item, id: i } }),
    }, onTriggerMessage, onSuccess);
  }

  async function postDeleteCourse(id) {
    const onSuccess = (_) => {
      courses[id].status = ObjectStatus.Deleted;
      setCourses({ ...courses });
      setCurrentCourse(defaultCourse);

      onTriggerMessage(
        "Success",
        "Successfully deleted course from the server",
      );

      closeDeleteConfirmation();
    };

    // Upload user guide
    await postDataWithHeaderHelper("/v1/courses/course/delete", {
      course_id: id
    }, onTriggerMessage, onSuccess);
  }

  async function postUpdateCourse(course) {
    const onSuccess = (data) => {
      const result = data.result.rows[0];

      let updatedCourse = { ...course };
      updatedCourse.status = ObjectStatus.Sync;
      updatedCourse.image_url = result.imageUrl;
      updatedCourse.image_local = false;

      const translationLength = result.addedTranslations.length;
      for (let i = 0; i < translationLength; i++) {
        const oldIndex = result.addedTranslations[i].oldIndex;
        // Update the index of the created course translation based on the index of the translation in course
        updatedCourse.course_translations[oldIndex].id = result.addedTranslations[i].newId;
      }

      updatedCourse.tags = updatedCourse.tags
        .filter((item) => item != ObjectStatus.Deleted)
        .map(function (item) { return { ...item, status: ObjectStatus.Sync } });

      updatedCourse.course_translations = updatedCourse.course_translations
        .filter((item) => item != ObjectStatus.Deleted)
        .map(function (item) { return { ...item, status: ObjectStatus.Sync } });

      courses[updatedCourse.id] = updatedCourse;

      const numOfFailedTranslation = result.failedTranslations;
      const numOfSuccessTranslation = result.successTranslations;
      const numOfFailedTag = result.failedTags;
      const numOfSuccessTag = result.successTags;

      const outMessage = `Successfully updated course on the server 
                          with success course translation update (${numOfSuccessTranslation}),
                          failed course translation update (${numOfFailedTranslation}),
                          success tag update (${numOfSuccessTag}),
                          failed tag update (${numOfFailedTag})`;

      setCurrentCourse(updatedCourse);
      setCourses({ ...courses });

      onTriggerMessage(
        "Success",
        outMessage,
      );
    };

    let deletedTags = [];
    let addedTags = [];
    let updatedTags = [];

    for (const [i, tag] of course.tags.entries()) {
      switch (tag.status) {
        case ObjectStatus.New:
          addedTags.push({ ...tag, index: i });
          break;
        case ObjectStatus.Updated: // Note, we are probably not using this
          updatedTags.push({ ...tag, index: i });
          break;
        case ObjectStatus.Deleted:
          deletedTags.push({ ...tag, index: i });
          break;
      }
    }

    const submitObject = {
      course_id: course.id,
      course_code: course.course_code,
      image_local: course.image_local,
      image_url: course.image_url,
      added_translations: course.course_translations
        .filter((c) => c.status == ObjectStatus.New)
        .map(function (item, i) { return { ...item, id: i } }),
      updated_translations: course.course_translations.filter((c) => c.status == ObjectStatus.Updated),
      deleted_translations: course.course_translations.filter((c) => c.status == ObjectStatus.Deleted),
      added_tags: addedTags,
      updated_tags: updatedTags,
      deleted_tags: deletedTags,
    };

    // Update course
    await postDataWithHeaderHelper("/v1/courses/course/update", submitObject, onTriggerMessage, onSuccess);
  }

  /*******************************************************************************************************
   *  Classes API functions
   ******************************************************************************************************/
  async function getClasses(courseId) {

    // If we have already loaded the classes, skip and use the cached ones
    if (classes[courseId] != undefined) {
      return;
    }

    const onSuccess = (data) => {
      let newClasses = [];
      const rows = data.result.rows;
      const length = rows.length;

      for (let i = 0; i < length; i++) {
        newClasses.push({
          status: ObjectStatus.Sync,
          id: parseInt(rows[i].class_id),
          course_id: parseInt(rows[i].course_id),
          location_id: parseInt(rows[i].location_id),
          trainer_id: parseInt(rows[i].trainer_id),
          trainer_name: rows[i].name,
          location_name: rows[i].location_name,
          address: rows[i].address,
          postal: rows[i].postal,
          start_date: new Date(rows[i].start_date),
          end_date: new Date(rows[i].end_date),
          language: rows[i].language,
          number_of_sessions: rows[i].number_of_sessions
        });
      }

      setClasses({ ...classes, [courseId]: newClasses });
      stopLoading();
    };

    startLoading();

    const submitObject = { courseId: courseId };

    // Get classes based on the courseId
    await postDataHelper("/v1/classes",
      submitObject,
      (title, content, type) => console.log(`${title}, ${content}, ${type}`),
      onSuccess);
  };

  async function getTrainers() {
    const onSuccess = (data) => {
      let newTrainers = [];
      const rows = data.result.rows;
      const length = rows.length;

      for (let i = 0; i < length; i++) {
        newTrainers.push({
          status: ObjectStatus.Sync,
          id: parseInt(rows[i].id),
          name: rows[i].name,
          role: rows[i].role,
          description: rows[i].description,
          image_url: rows[i].image_url,
        });
      }

      setTrainers(newTrainers);
    };

    // Get classes based on the courseId
    await getDataHelper("/v1/trainers",
      (title, content, type) => console.log(`${title}, ${content}, ${type}`),
      onSuccess);
  };

  async function getLocations() {

    const onSuccess = (data) => {
      let newLocations = [];
      const rows = data.result.rows;
      const length = rows.length;

      for (let i = 0; i < length; i++) {
        newLocations.push({
          status: ObjectStatus.Sync,
          id: parseInt(rows[i].id),
          name: rows[i].name,
          address: rows[i].address,
          postal: rows[i].postal,
        });
      }

      setLocations(newLocations);
    };

    // Get classes based on the courseId
    await getDataHelper("/v1/locations",
      (title, content, type) => console.log(`${title}, ${content}, ${type}`),
      onSuccess);
  };

  useEffect(() => {
    async function fetchData() {
      await getCourses(["zh", "en"], {});
      await getLocations();
      await getTrainers();
    }

    fetchData();
  }, []);

  /*******************************************************************************************************
   *  Functions that trigger the modal form
   ******************************************************************************************************/
  function onAddCourse() {
    setCurrentCourse(defaultCourse);
    showCourseForm();
  }

  function onUpdateCourse(id) {
    setCurrentCourse(courses[id]);
    showCourseForm();
  }

  async function onDeleteCourseConfirmation() {
    await postDeleteCourse(currentCourse.id);
  }

  function onDeleteCourse(id) {
    setCurrentCourse(courses[id]);
    showDeleteConfirmation();
  }

  /*******************************************************************************************************
   *  Functions for CourseForms
   ******************************************************************************************************/

  function saveFormToCurrentResource() {
    /// Save current form content to current course so that any refresh behavior does not lose changes
    const newCourse = getLatestCourseBasedOnForm();
    setCurrentCourse(newCourse);
  }

  /**
   * Convert current form input and apply it onto the currentCourse so
   * we will have the latest course information
   * @returns latest course
   */
  function getLatestCourseBasedOnForm() {
    /// Convert and merge form values into currentCourse
    const conversionMap = {
      'id': 'id',
      'tag': 'tag',
      'courseCode': 'course_code',
      'description': 'description',
      'imageUrl': 'image_url',
      'imageFile': 'image_file',
      'imageLocal': 'image_local',
    };

    let newCourse = currentCourse;

    // We want to merge formValues with currentCourse so it does not get lost
    Object.entries(formValues).forEach(([key, value]) => {
      if (key.startsWith('translation')) {
        const tokens = key.split('.');
        // [translations].[index].[key]
        const index = parseInt(tokens[1]);
        newCourse.course_translations[index][tokens[2]] = value;
        newCourse.course_translations[index].status =
          newCourse.course_translations[index].status != ObjectStatus.New
            ? ObjectStatus.Updated
            : ObjectStatus.New;
      } else {
        newCourse[conversionMap[key]] = value;
      }
    });

    // If we call this function, we probably updated something
    newCourse.status = ObjectStatus.Updated;

    return newCourse;
  }

  function onChange(e) {
    formValues = { ...formValues, [e.target.name]: e.target.value };
    let updateCourse = getLatestCourseBasedOnForm();
    setCurrentCourse({ ...updateCourse });
  }

  function onTagChange(e) {
    if (e.keyCode == ENTER_KEY) {
      let updateCourse = getLatestCourseBasedOnForm();
      updateCourse.tags.push({ tag: e.target.value, status: ObjectStatus.New });
      updateCourse.tag = "";
      setCurrentCourse({ ...updateCourse });
    }
  }

  function onTagClickDeleteHandler(name) {
    let updateCourse = getLatestCourseBasedOnForm();
    // Find index and update status to deleted
    const index = updateCourse.tags.findIndex((tag) => tag.tag == name);
    updateCourse.tags[index].status = ObjectStatus.Deleted;
    setCurrentCourse({ ...updateCourse });
  }

  function onAddTranslation() {
    let updateCourse = getLatestCourseBasedOnForm();
    updateCourse.course_translations.push({ ...defaultTranslation });
    setCurrentCourse({ ...updateCourse });
  }

  function onDeleteTranslation(index) {
    let updateCourse = getLatestCourseBasedOnForm();
    updateCourse.course_translations[index].status = ObjectStatus.Deleted;
    setCurrentCourse({ ...updateCourse });
  }

  function onImageUpload(filePath) {
    if (filePath == undefined) {
      onTriggerMessage(
        "File is not defined",
        `Select file is not defined, please try again. Accepted extensions are: ${acceptedExts}`,
        "danger"
      );
      return;
    }

    const filename = filePath[0].name;
    const ext = filename.split('.').pop();
    const acceptedExts = ["png", "jpeg"];

    // If the ext is not in the include list, we will not upload the file
    if (!acceptedExts.includes(ext)) {
      saveFormToCurrentResource();
      onTriggerMessage(
        "Invalid file extension",
        `We do not accept this file extension ${ext}, accepted formats: ${acceptedExts}`,
        "danger"
      );
      return;
    }

    let updatedCourse = getLatestCourseBasedOnForm();
    updatedCourse.status = ObjectStatus.Updated;
    updatedCourse.image_local = true;
    updatedCourse.image_url = filename;
    updatedCourse.image_file = filePath[0];

    // try to upload file to tmp location
    uploadCourseImage(updatedCourse);
  }

  /**
   * Check if the course input is valid
   * @param {*} course 
   * @returns true if all is valid, else false
   */
  function checkCourseValid(course) {

    if (!course.course_code || !course.image_url) {
      onTriggerMessage(
        "Fail to submit course",
        `Make sure you fill in the course code or the image url`,
        "danger"
      );
      return false;
    }

    if (course.course_translations.length == 0) {
      onTriggerMessage(
        "Fail to submit course",
        `Make sure there is at least one translation for the course...`,
        "danger"
      );

      return false;
    }

    for (const courseTranslation of course.course_translations) {
      if (!courseTranslation.name || !courseTranslation.description || !courseTranslation.language) {
        onTriggerMessage(
          "Fail to submit course",
          `Make sure all your translations are valid...`,
          "danger"
        );
        return false;
      }
    }

    return true;
  }

  async function onAddSubmit() {
    let latestCourse = getLatestCourseBasedOnForm();

    if (!checkCourseValid(latestCourse)) {
      return;
    }

    await postCourse(latestCourse);
  }

  async function onEditSubmit() {
    let latestCourse = getLatestCourseBasedOnForm();

    if (!checkCourseValid(latestCourse)) {
      return;
    }

    await postUpdateCourse(latestCourse);
  }

  /*******************************************************************************************************
   *  Functions for Classes Form
   ******************************************************************************************************/
  async function onShowClasses(id) {
    await getClasses(id);
    setCurrentCourse(courses[id]);
    showClassesModal();
  }

  function onCloseClasses() {
    closeClassesModal();
  }

  function onClassAdd(cls) {

    if (classes[cls.course_id] != undefined) {
      classes[cls.course_id].push(cls);
    }
    else {
      classes[cls.course_id] = [cls];
    }

    setClasses(classes);
  }

  function onClassEdit(cls) {
    const index = classes[cls.course_id].findIndex((c) => c.id == cls.id);
    classes[cls.course_id][index] = cls;
    setClasses({ ...classes });
  }

  function onClassDelete(cls) {
    classes[cls.course_id] = classes[cls.course_id].filter((c) => c.id != cls.id);
    setClasses({ ...classes });
  }

  /*******************************************************************************************************
   *  Functions for Locations Form
   ******************************************************************************************************/
  function onShowLocations() {
    showLocationsModal();
  }

  function onCloseLocations() {
    closeLocationsModal();
  }

  function onLocationAdd(location) {
    locations.push(location);
    setLocations(locations);
  }

  function onLocationEdit(location) {
    const index = locations.findIndex((l) => l.id == location.id);
    locations[index] = location;
    setLocations([...locations]);
  }

  function onLocationDelete(location) {
    let updatedLocation = locations.filter((l) => l.id != location.id);
    setLocations([...updatedLocation]);
  }

  /*******************************************************************************************************
   *  Functions for Courses
   ******************************************************************************************************/
  function CourseDetails({ course, totalNumberOfSpace }) {
    // We will use english title first, else if not available use chinese
    const name = course.course_translations[0].name;
    const languages = course.course_translations.map((item) => getLanguage(item.language)).join(", ");

    return (
      <Fragment key={`${course.id}_fragment`}>
        <tr key={`${course.id}_course_title_row`}><th colSpan={totalNumberOfSpace}>{name}</th></tr>
        <tr key={`${course.id}_guide_row`}>
          <td>{course.id}</td>
          <td>{course.course_code}</td>
          <td><Button key={`${course.id}_view_classes_btn`} variant="light" onClick={() => onShowClasses(course.id)}>See Classes</Button></td>
          <td colSpan={2}>{name}</td>
          <td><Image src={course.image_url} style={{ height: "5vw", width: "5vw" }} rounded /></td>
          <td><CourseTagBadgeDisplay tags={course.tags} /></td>
          <td>{languages}</td>
          <td>{course.likes}</td>
          <td><Button key={`${course.id}_update_course_btn`} variant="primary" onClick={() => onUpdateCourse(course.id)}>Edit</Button></td>
          <td><Button key={`${course.id}_delete_course_btn`} variant="danger" onClick={() => onDeleteCourse(course.id)}>Delete</Button></td>
        </tr>
        <tr key={`${course.id}_course_blank_row`}><td colSpan={totalNumberOfSpace}></td></tr>
      </Fragment>
    );
  }

  function CourseEntry({ course, index, totalNumberOfSpace }) {
    return (
      <Fragment key={`${course.id}_${index}_crud_main_fragment`}>
        {course.status !== ObjectStatus.Deleted
          ? <CourseDetails course={course} totalNumberOfSpace={totalNumberOfSpace} />
          : <Fragment key={`${course.id}_fragment_deleted`}></Fragment>
        }
      </Fragment>
    );
  }

  function CoursesTable({ displayCourses }) {
    const totalNumberOfSpace = 11;

    return (
      <Table responsive="sm">
        <tbody>
          <tr key="course_header_row">
            <th>ID</th>
            <th>Course Code</th>
            <th>Classes</th>
            <th colSpan={2}>Name</th>
            <th>Image</th>
            <th>Tags</th>
            <th>Language(s) Available</th>
            <th>Likes</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
          <tr key="course_header_blank_row"><td colSpan={totalNumberOfSpace}></td></tr>
          {Object.values(displayCourses).map(function (item, index) {
            return <CourseEntry
              key={`${item.id}_${index}_course_entry`}
              totalNumberOfSpace={totalNumberOfSpace}
              course={item}
              index={index} />;
          })}
        </tbody >
      </Table >
    );
  }

  return (
    <>
      <NavBar />
      <div className="container-content-fixed">
        <div className="courses-hdr-grp">
          <Header title="Courses" />
          <div className="courses-hdr-grp">
            <Button onClick={onShowLocations}>Manage Locations</Button>
            <Button onClick={onAddCourse}>Add New Course</Button>
          </div>
        </div>
        {/* Display all the courses in the database */}
        <CoursesTable displayCourses={courses} />
        {/* Display the course form, hidden by default */}
        <CourseForm
          currentCourse={currentCourse}
          onTriggerMessage={onTriggerMessage}
          showFlag={showCourseFormFlag}
          onChange={onChange}
          onFormClose={closeCourseForm}
          onImageUpload={onImageUpload}
          onTagChange={onTagChange}
          onTagClickDeleteHandler={onTagClickDeleteHandler}
          onAddTranslation={onAddTranslation}
          onDeleteTranslation={onDeleteTranslation}
          onCreate={onAddSubmit}
          onUpdate={onEditSubmit}
        />
        {/* Display the classes modal, hidden by default */}
        <ClassesModal
          onTriggerMessage={onTriggerMessage}
          classes={classes[currentCourse.id]}
          currentCourse={currentCourse}
          isLoading={isLoading}
          showFlag={showClassesModalFlag}
          trainers={trainers}
          locations={locations}
          onFormClose={onCloseClasses}
          onClassAdd={onClassAdd}
          onClassEdit={onClassEdit}
          onClassDelete={onClassDelete} />
        {/* Display the locations modal, hidden by default */}
        <LocationsModal
          onTriggerMessage={onTriggerMessage}
          isLoading={isLoading}
          showFlag={showLocationsModalFlag}
          locations={locations}
          onFormClose={onCloseLocations}
          onLocationAdd={onLocationAdd}
          onLocationEdit={onLocationEdit}
          onLocationDelete={onLocationDelete} />
        {/* Display the delete confirmation below we allow deletion */}
        <DeleteConfirmation
          title={currentCourse.course_code}
          description="Are you sure you want to delete this course? Any classes that are linked to this course will be deleted!"
          showFlag={showDeleteConfirmationFlag}
          onConfirmation={onDeleteCourseConfirmation}
          onClose={closeDeleteConfirmation} />
      </div>
    </>
  );
};

export default EditCourses;
